export default __webpack_public_path__ + "static/media/bar-maintenance.35886d22.svg";